import { Routes, Route } from '@angular/router';
import { CoreComponent } from './core.component';

export class CoreService {
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: CoreComponent,
      children: routes,
      data: { reuse: true }
    };
  }

}
